import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  inject
} from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { CompanyVendor, ExemptVendor, Vendor } from 'src/app/classes/models';
import { GridActionColumnActions } from 'src/app/interfaces/grid-action-column-actions';
import { GridActionColumnMap } from 'src/app/interfaces/grid-action-column-map';
import { CompanyVendorService } from 'src/app/services/company-vendor.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-client-my-vendors-qsb',
  templateUrl: './client-my-vendor-qsb.component.html',
  styleUrls: ['./client-my-vendor-qsb.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ClientMyVendorQsbComponent implements OnInit {
  private _cdr = inject(ChangeDetectorRef);

  constructor(
    private route: ActivatedRoute,
    private Router: Router,
    private CompanyVendorService: CompanyVendorService,
    private ToastService: ToastService
  ) {}

  Vendor!: Vendor | ExemptVendor;

  suppliedGridQueryData: {
    [key: string]: any;
  } = {};

  ColumnIdToColumnActions: GridActionColumnMap = {
    ['$actionColumn']: ['view']
  };

  action({
    action,
    rowData
  }: {
    action: GridActionColumnActions;
    rowData: any;
  }) {
    if (action === 'view') {
      this.Router.navigate(['proposal-request', rowData.ProposalRequestId], {
        relativeTo: this.route
      });
    }
  }

  ngOnInit(): void {
    const paramMap: ParamMap = this.route.snapshot.paramMap;
    const VendorId = Number(paramMap.get('VendorId')) || null;
    const ExemptVendorId = Number(paramMap.get('ExemptVendorId')) || null;
    const companyVendorQuery = {};
    const vendorQuery = {
      attributes: ['legalName']
    };

    if (VendorId) {
      Object.assign(this.suppliedGridQueryData, { VendorId });
      Object.assign(companyVendorQuery, {
        VendorId,
        Vendor: JSON.stringify(vendorQuery)
      });
    }

    if (ExemptVendorId) {
      Object.assign(this.suppliedGridQueryData, { ExemptVendorId });
      Object.assign(companyVendorQuery, {
        ExemptVendorId,
        ExemptVendor: JSON.stringify(vendorQuery)
      });
    }

    this.CompanyVendorService.getCompanyVendor(companyVendorQuery).subscribe({
      next: (CompanyVendor: CompanyVendor) => {
        if (!CompanyVendor) {
          throw this.ToastService.addErrorToast(
            'Error',
            'No CompanyVendor Record Found.',
            { returnError: true }
          );
        }

        const { Vendor, ExemptVendor } = CompanyVendor;

        if (Vendor) {
          this.Vendor = Vendor;
        }

        if (ExemptVendor) {
          this.Vendor = ExemptVendor;
        }
        this._cdr.markForCheck();
      },
      error: (err) => {
        throw this.ToastService.addErrorToast('Error', err, {
          returnError: true
        });
      }
    });
  }
}
